/**
 * Day-related constants and mappings
 * Centralized location for all day-of-week related data used across the application
 */

export enum DayOfWeek {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

// Full day names for display in results and detailed text
export const FULL_DAY_NAMES = {
  [DayOfWeek.SUNDAY]: 'Sunday',
  [DayOfWeek.MONDAY]: 'Monday',
  [DayOfWeek.TUESDAY]: 'Tuesday',
  [DayOfWeek.WEDNESDAY]: 'Wednesday',
  [DayOfWeek.THURSDAY]: 'Thursday',
  [DayOfWeek.FRIDAY]: 'Friday',
  [DayOfWeek.SATURDAY]: 'Saturday',
} as const;

// Abbreviated day names for UI elements like buttons and calendar labels
export const DAY_ABBREVIATIONS = {
  [DayOfWeek.SUNDAY]: 'Sun',
  [DayOfWeek.MONDAY]: 'Mon',
  [DayOfWeek.TUESDAY]: 'Tues',
  [DayOfWeek.WEDNESDAY]: 'Wed',
  [DayOfWeek.THURSDAY]: 'Thurs',
  [DayOfWeek.FRIDAY]: 'Fri',
  [DayOfWeek.SATURDAY]: 'Sat',
} as const;

// Type exports for components that need the day interface
export interface CustomDoseDay {
  day: DayOfWeek;
  dose: number;
}
